import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/** shareReplay GET cache keyed by caller-provided string (e.g. `nodeId::assessmentId`). */
export function getOrCreateCachedObservable<T>(
	cache: Map<string, Observable<T>>,
	key: string,
	factory: () => Observable<T>,
	options?: { refCount?: boolean }
): Observable<T> {
	let shared = cache.get(key);
	if (!shared) {
		shared = factory().pipe(shareReplay({ bufferSize: 1, refCount: options?.refCount ?? true }));
		cache.set(key, shared);
	}
	return shared;
}

export function pruneCacheExceptPrefix(cache: Map<string, unknown>, keepKey: string, keepPrefix: string): void {
	for (const k of [...cache.keys()]) {
		if (!(k === keepKey || k.startsWith(keepPrefix))) {
			cache.delete(k);
		}
	}
}

export function deleteCacheWithPrefix(cache: Map<string, unknown>, prefix: string): void {
	for (const k of [...cache.keys()]) {
		if (k === prefix || k.startsWith(`${prefix}::`)) {
			cache.delete(k);
		}
	}
}
